import { render, staticRenderFns } from "./toemail-add-or-update.vue?vue&type=template&id=584b51c8&"
import script from "./toemail-add-or-update.vue?vue&type=script&lang=js&"
export * from "./toemail-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports